module.exports = __webpack_public_path__ + "img/system_flow_04.png";